"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseBannerComponent = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const license_banner_style_1 = require("../../components/license.banner/license.banner.style");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const icon_1 = require("../icon");
const icons_1 = require("../icon/icons");
const mithril_component_1 = require("../mithril.component");
class LicenseBannerComponent extends mithril_component_1.IMithrilComponent {
    constructor() {
        super();
        this.name = 'LicenseBanner';
        this.bannerVisible = false;
        (0, mobx_1.autorun)(() => {
            this.bannerVisible = services_1.Services.License.hasNoLicense;
        });
    }
    onremove() {
        if (this.disposer) {
            this.disposer();
        }
    }
    get nodes() {
        if (this.bannerVisible) {
            return (0, mithril_1.m)('div', { className: license_banner_style_1.CSS.alert }, [
                (0, mithril_1.m)('span', { className: license_banner_style_1.CSS.License }, [
                    (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_TEXT),
                    (0, mithril_1.m)('a', { className: license_banner_style_1.CSS.alertHref, href: 'https://ikegps.zendesk.com/hc/en-us/articles/24400055764237-How-to-Admin-IKE-Office-Pro-User-Seats-Using-IKE-Access-FAQ', target: '_blank' }, (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_LINK)),
                    '.'
                ]),
                (0, mithril_1.m)('span', { className: license_banner_style_1.CSS.License }, [
                    (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT),
                    (0, mithril_1.m)('a', { className: license_banner_style_1.CSS.alertHref, href: `mailto:${(0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL)}` }, (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL)),
                    '.'
                ]),
                (0, mithril_1.m)('button', {
                    className: license_banner_style_1.CSS.closeButton,
                    onclick: () => {
                        services_1.Services.License.hasNoLicense = false;
                        this.bannerVisible = false;
                    },
                    title: i18n_1.T.CLOSE
                }, [
                    (0, i18n_1.Translate)(i18n_1.T.DISMISS),
                    icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, {
                        className: license_banner_style_1.CSS.closeIcon
                    })
                ])
            ]);
        }
        return null;
    }
}
exports.LicenseBannerComponent = LicenseBannerComponent;
tslib_1.__decorate([
    mobx_1.observable
], LicenseBannerComponent.prototype, "bannerVisible", void 0);
tslib_1.__decorate([
    mobx_1.computed
], LicenseBannerComponent.prototype, "nodes", null);
//# sourceMappingURL=license.banner.js.map